import React, { useEffect, useState } from "react";
import Modal from "antd/es/modal/Modal";
import { sendEmail } from "../services/authService";
import { toast } from "react-toastify";

function Field({ label, value, onChange, type = "text", placeholder, error }) {
  return (
    <label className="block">
      <span className="block text-xs font-medium text-slate-700 mb-1">{label}</span>
      <input
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-4 focus:ring-blue-100"
      />
      {error && <p className="mt-1 text-xs text-rose-600">{error}</p>}
    </label>
  );
}

export default function ModalSendEmail({ open, onCancel, sending = false }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setEmail("");
      setError("");
    }
  }, [open]);

  const validate = (value) => {
    const v = (value || "").trim();
    if (!v) return "El email es requerido";
    // simple email regex
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(v)) return "Email inválido";
    return "";
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const err = validate(email);
    setError(err);
    if (err) return;
    try {
      setLoading(true);
      const response= await sendEmail(email);
      if (!response.ok) {
        toast.error(response.message || "Error enviando el correo. Intenta de nuevo.");
        return
      }
      toast.success("Correo de recuperación enviado. Revisa tu bandeja de entrada.");
      onCancel();

    } catch (err) {
      console.error(err);
      setError("Error enviando el correo. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onCancel={onCancel} title="Recuperar contraseña" footer={null} width={520}>
      {loading || sending ? (
        <div className="space-y-3">
          <div className="h-4 w-48 bg-slate-200 rounded animate-pulse" />
          <div className="h-10 w-full bg-slate-100 rounded-xl animate-pulse" />
          <div className="flex justify-end gap-2 pt-2">
            <div className="h-9 w-20 bg-slate-100 rounded-xl animate-pulse" />
            <div className="h-9 w-32 bg-slate-200 rounded-xl animate-pulse" />
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-sm text-slate-600">Ingresa el email de la cuenta y recibirás un enlace para restablecer la contraseña.</p>
          <Field
            label="Email"
            type="email"
            value={email}
            onChange={(v) => setEmail(v)}
            placeholder="correo@ejemplo.com"
            error={error}
          />

          <div className="flex items-center justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onCancel}
              className="rounded-xl border border-slate-300 px-4 py-2 text-sm hover:bg-slate-100 transition"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="rounded-xl bg-blue-600 text-white px-4 py-2 text-sm hover:bg-blue-700 disabled:opacity-60 transition"
            >
              Enviar enlace
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
}
